import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface TableColumn {
    key: string;
    label: string;
    sortable?: boolean;
    truncate?: boolean;
    type?: 'text' | 'link' | 'dash-if-empty';
}

export interface TableAction {
    label: string;
    key: string;
}

@Component({
    selector: 'lokos-table',
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss',
    standalone: false,
})
export class TableComponent {
    @Input() columns: TableColumn[] = [];
    @Input() rows: any[] = [];
    @Input() actions: TableAction[] = [];
    @Input() sortKey = '';
    @Input() sortDir: 'asc' | 'desc' | '' = '';
    @Input() linkColumnKey = '';

    @Output() sortChange = new EventEmitter<{ key: string; dir: 'asc' | 'desc' }>();
    @Output() linkClick = new EventEmitter<any>();
    @Output() actionClick = new EventEmitter<{ key: string; row: any }>();

    openMenuIndex = -1;

    onSort(col: TableColumn) {
        if (!col.sortable) return;
        let dir: 'asc' | 'desc' = 'asc';
        if (this.sortKey === col.key && this.sortDir === 'asc') {
            dir = 'desc';
        }
        this.sortChange.emit({ key: col.key, dir });
    }

    toggleMenu(index: number, event: Event) {
        event.stopPropagation();
        this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
    }

    closeMenus() {
        this.openMenuIndex = -1;
    }

    onActionClick(actionKey: string, row: any, event: Event) {
        event.stopPropagation();
        this.openMenuIndex = -1;
        this.actionClick.emit({ key: actionKey, row });
    }

    onLinkClick(row: any) {
        this.linkClick.emit(row);
    }

    getCellValue(row: any, col: TableColumn): string {
        const value = row[col.key];
        if (col.type === 'dash-if-empty' && (!value || value === '')) return '-';
        return value !== undefined && value !== null ? String(value) : '';
    }
}
